import { Link } from '@farmersdog/corgi-x';
import { SOCIAL_LINKS } from '../constants';

import styles from './SocialLinks.module.css';

export const SocialLinks = () => {
  return (
    <ul className={styles.socialLinks} aria-label="Social links">
      {SOCIAL_LINKS.map(({ icon: Icon, ...linkProps }) => (
        <li key={linkProps.href}>
          <Link {...linkProps} style={{ fill: 'white' }}>
            {Icon && <Icon />}
          </Link>
        </li>
      ))}
    </ul>
  );
};
